enum LoadableState {
	Unloaded = 'Unloaded',
	Pending = 'Pending',
	FulFilled = 'FulFilled',
	Rejected = 'Rejected',
}

export default LoadableState;
